export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Откуда"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Куда"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сумма"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевести"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перевод по своим счетам"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Переводы внутри кошелька"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счета отправителя и получателя должны быть различны"])}
}